// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3zDT-","row":"Node_row__1Isn-","label":"Node_label__16G5v","footer":"Node_footer__2OZ5G"};